import anime from '../libs/anime'
import hammer from '../libs/hammer'
import globalVar from '../utils/globalVar'

class Module09Chrono {
  constructor() {
    let cache = {};
    let interval;
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
        cache.slider = document.querySelectorAll('.module-09-chrono .slider_swipe');
        cache.dates = document.querySelectorAll('.module-09-chrono .dates_wrapper .date');
    }

    let registerEvents = () => {
        for (let i = 0; i < cache.slider.length; i++) {
            if(cache.slider[i].querySelectorAll('.slide_img').length > 1) {
              let sliderL = cache.slider[i].querySelector('.slider_left');
              sliderL.addEventListener('click', function(){slideRight(this, true)});
              let hammertime = new Hammer(cache.slider[i]);
              hammertime.on('swipe', function(ev) {
                if(ev.direction == 2) {
                  slideRight(sliderL, true);
                }
                if(ev.direction == 4) {
                  slideRight(sliderL, false);
                }
              });
              interval = setInterval(function () {slideRight(sliderL, true); }, 6000);
            }
          }
          for (let i = 0; i < cache.dates.length; i++) {
            cache.dates[i].addEventListener('click', dateSwitch);
          }
    }

    let dateSwitch = function() {
        let targetDate = this;
        let targetIndex = targetDate.dataset.index;
        let parent = targetDate.parentNode.parentNode;
        let datesWrapper = targetDate.parentNode;
        let slider = parent.querySelectorAll('.slider_swipe');
        let activeDate = parent.querySelector('.date.active');
        let activeIndex = activeDate.dataset.index;
    
        activeDate.classList.remove('active');
        if(activeDate.previousElementSibling) {
          activeDate.previousElementSibling.classList.remove('active');
        }
        if(activeDate.nextElementSibling) {
          activeDate.nextElementSibling.classList.remove('active');
        }
    
        targetDate.classList.add('active');
        if(targetDate.nextElementSibling) {
          targetDate.nextElementSibling.classList.add('active');
        }
        if(targetDate.previousElementSibling) {
          targetDate.previousElementSibling.classList.add('active');
        }
    
        anime({
          targets: slider[activeIndex],
          opacity: 0,
          scale: [1,0.9],
          translateX: [0, -100],
          duration: 500,
          easing: 'easeOutSine',
          complete: function() {
            slider[activeIndex].style.display="none";
          }
        });
    
        slider[targetIndex].style.display="flex";
        anime({
          targets: slider[targetIndex],
          opacity: [0,1],
          scale: [0.9,1],
          translateX: [100, 0],
          duration: 500,
          easing: 'easeOutSine',
        });
      }

      let slideRight = function(sliderLeft, dir) {
        clearInterval(interval);
        let slider = sliderLeft.parentNode;
        slider.style.pointerEvents = "none";
        let i = slider.dataset.index;
        let img = slider.querySelectorAll('.slide_img');
        let txt = slider.querySelectorAll('.slide_content');
        let num = slider.querySelector('.num .txt');
        let imax = img.length;
    
        let currentImg = img[i];
        let currentTxt = txt[i];
    
        if(i < imax-1){
          i++;
          slider.dataset.index = i;
        }
        else {
          i = 0;
          slider.dataset.index = i;
        }
    
        let nxtImg = img[i];
        let nxtTxt = txt[i];
        let nxt2Img;
        let nxt3Img;
    
        if(imax > 2) {
          if(i < (imax-1)){
            nxt2Img = img[i+1];
          }
          else {
            nxt2Img = img[0];
          }
    
          if((i+1) < (imax-1)){
            nxt3Img = img[i+2];
          }
          else if((i+1) == (imax-1)){
            nxt3Img = img[0];
          }
          else {
            nxt3Img = img[1];
          }
        }
    
        else {
          if((i == 0)){
            nxt3Img = img[1];
          }
          else if(i == 1){
            nxt3Img = img[0];
          }
        }
    
    
    // Anime txt
        if(globalVar.desktop.matches) {
            anime({
            targets: currentTxt,
            opacity: 0,
            translateX: ['-50%', '-40%'],
            translateY: ['-50%','-50%'],
            duration: 500,
            easing: 'easeOutSine',
            });
            anime({
            targets: nxtTxt,
            opacity: [0,1],
            translateX: ['-60%', '-50%'],
            translateY: ['-50%','-50%'],
            scale: [0.9,1],
            duration: 500,
            easing: 'easeOutSine',
            });
        } else {
            anime({
                targets: currentTxt,
                opacity: 0,
                duration: 500,
                easing: 'easeOutSine',
                });
                anime({
                targets: nxtTxt,
                opacity: [0,1],
                scale: [0.9,1],
                duration: 500,
                easing: 'easeOutSine',
                });
        }
    
    // Anime number
    if(num) {
        anime({
          targets: num,
          opacity: 0,
          translateX: -10,
          duration: 300,
          easing: 'easeOutSine',
          complete: function() {
            num.innerHTML = i+1;
            anime({
              targets: num,
              opacity: 1,
              translateX: 0,
              duration: 300,
              easing: 'easeOutSine',
            });
          }
        });
      }
    
    // Anime Img
      if(dir) {
        anime({
          targets: currentImg,
          opacity: 0,
          translateX: ['-50%', '-20%'],
          translateY: ['-50%','-50%'],
          scale: [1,0.8],
          rotate: 15,
          duration: 400,
          easing: 'easeOutSine',
          complete: function() {
            currentImg.style.zIndex=0;
            nxtImg.style.zIndex=3;
            if(imax > 2) {
              nxt2Img.style.zIndex=2;
            }
            if(nxt3Img) {
              nxt3Img.style.zIndex=1;
              anime({
                targets: nxt3Img,
                translateX: ['-50%', '-50%'],
                translateY: ['-50%','-50%'],
                opacity: 1,
                scale: [0.8,1],
                rotate: [-20,-10],
                duration: 400,
                easing: 'easeOutSine',
                complete: function() {
                  slider.style.pointerEvents = "all";
                  for (let i = 0; i < cache.slider.length; i++) {
                    let sliderL = cache.slider[i].querySelector('.slider_left');
                    if(!interval) {
                      interval = setInterval(function () {slideRight(sliderL, true);}, 6000);
                    }
                  }
                }
              });
            }
          }
        });
      }
      else {
        anime({
          targets: currentImg,
          opacity: 0,
          translateX: ['-50%', '-70%'],
          translateY: ['-50%','-50%'],
          scale: [1,0.8],
          rotate: -15,
          duration: 400,
          easing: 'easeOutSine',
          complete: function() {
            currentImg.style.zIndex=0;
            nxtImg.style.zIndex=3;
            if(imax > 2) {
              nxt2Img.style.zIndex=2;
            }
            if(nxt3Img) {
              nxt3Img.style.zIndex=1;
              anime({
                targets: nxt3Img,
                translateX: ['-50%', '-50%'],
                translateY: ['-50%','-50%'],
                opacity: 1,
                scale: [0.8,1],
                rotate: [-20,-10],
                duration: 400,
                easing: 'easeOutSine',
                complete: function() {
                  slider.style.pointerEvents = "all";
                  for (let i = 0; i < cache.slider.length; i++) {
                    let sliderL = cache.slider[i].querySelector('.slider_left');
                    if(!interval) {
                      interval = setInterval(function () {slideRight(sliderL, true);}, 6000);
                    }
                  }
                }
              });
            }
          }
        });
      }
    
          anime({
            targets: nxtImg,
            translateX: ['-50%', '-50%'],
            translateY: ['-50%','-50%'],
            rotate: [10,0],
            delay: 100,
            duration: 400,
            easing: 'easeOutSine',
          });
    
          if(imax > 2) {
            anime({
              targets: nxt2Img,
              translateX: ['-50%', '-50%'],
              translateY: ['-50%','-50%'],
              rotate: [-10,10],
              delay:100,
              duration: 400,
              easing: 'easeOutSine',
            });
          }
      }
    
    
    initFunc();
  }
}
export { Module09Chrono }